export const Field = ({ label, name, type = "text", value, onChange, required, placeholder, testid, half }) => (
  <div className={half ? "" : "sm:col-span-2"}>
    <label className="mb-1.5 block text-sm font-medium text-slate-600">
      {label} {required && <span className="text-gold">*</span>}
    </label>
    <input
      data-testid={testid}
      name={name}
      type={type}
      value={value}
      onChange={onChange}
      required={required}
      placeholder={placeholder}
      className="w-full rounded-lg border border-slate-300 bg-[#FAF8F1] px-4 py-2.5 text-sm text-[#0B132B] placeholder-slate-400 focus:border-gold focus:bg-white focus:outline-none"
    />
  </div>
);

export const SelectField = ({ label, name, value, onChange, options, required, testid, half }) => (
  <div className={half ? "" : "sm:col-span-2"}>
    <label className="mb-1.5 block text-sm font-medium text-slate-600">
      {label} {required && <span className="text-gold">*</span>}
    </label>
    <select
      data-testid={testid}
      name={name}
      value={value}
      onChange={onChange}
      required={required}
      className="w-full rounded-lg border border-slate-300 bg-[#FAF8F1] px-4 py-2.5 text-sm text-[#0B132B] focus:border-gold focus:bg-white focus:outline-none"
    >
      <option value="">Select…</option>
      {options.map((o) => (
        <option key={o} value={o}>{o}</option>
      ))}
    </select>
  </div>
);

export const TextArea = ({ label, name, value, onChange, placeholder, testid, required }) => (
  <div className="sm:col-span-2">
    <label className="mb-1.5 block text-sm font-medium text-slate-600">
      {label} {required && <span className="text-gold">*</span>}
    </label>
    <textarea
      data-testid={testid}
      name={name}
      value={value}
      onChange={onChange}
      required={required}
      placeholder={placeholder}
      rows={4}
      className="w-full rounded-lg border border-slate-300 bg-[#FAF8F1] px-4 py-2.5 text-sm text-[#0B132B] placeholder-slate-400 focus:border-gold focus:bg-white focus:outline-none"
    />
  </div>
);

export const FileField = ({ label, onChange, testid }) => (
  <div className="sm:col-span-2">
    <label className="mb-1.5 block text-sm font-medium text-slate-600">{label}</label>
    <input
      data-testid={testid}
      type="file"
      multiple
      onChange={onChange}
      className="block w-full text-sm text-slate-500 file:mr-4 file:rounded-full file:border-0 file:bg-gold/10 file:px-4 file:py-2 file:text-sm file:font-semibold file:text-gold hover:file:bg-gold/20"
    />
    <p className="mt-1 text-xs text-slate-400">PDFs, auction documents, property lists, photos, spreadsheets.</p>
  </div>
);
